import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppConfig } from './config/routes.config';
import { AuthGuard } from './core/guards/auth.guard';


const appRoutes = AppConfig.routes;

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
		path: 'auth',
		loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
	},
  {
		path: appRoutes.auth.resetPassword.path,
		loadChildren: () => import('./modules/auth/new-password/new-password.module').then(m => m.NewPasswordPageModule),
	},
 	{
		path: 'home',
		loadChildren: () => import('./modules/home-wrapper/home-wrapper.module').then(m => m.HomeWrapperPageModule)
	},
  {
    path: 'account',
    loadChildren: () => import('./modules/account-wrapper/account-wrapper.module').then( m => m.AccountWrapperPageModule),
    canActivate: [AuthGuard],
    data: { goToLogin: true}
  },
  {
    path: 'settings',
    loadChildren: () => import('./modules/settings-wrapper/settings-wrapper.module').then(m => m.SettingsWrapperPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'support',
    loadChildren: () => import('./modules/support-wrapper/support-wrapper.module').then( m => m.SupportWrapperPageModule)
  },
  {
    path: 'emails',
    loadChildren: () => import('./modules/auth/unsubscribe/unsubscribe.module').then(m => m.UnsubscribePageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule, TranslateModule]
})
export class AppRoutingModule {}
